import { render, staticRenderFns } from "./CustomerAddressInputs.vue?vue&type=template&id=84e50a08&"
import script from "./CustomerAddressInputs.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports